import { render, staticRenderFns } from "./add-case.vue?vue&type=template&id=2f7692c4&"
import script from "./add-case.vue?vue&type=script&lang=js&"
export * from "./add-case.vue?vue&type=script&lang=js&"
import style0 from "./add-case.vue?vue&type=style&index=0&id=2f7692c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports